import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Flame } from "lucide-react";

/**
 * Site-wide banner shown every Monday (or when admin flips the override on).
 * Points fans at the artist profile hunt.
 */
export default function MeloMondayBanner() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    api.get("/config/public").then((r) => setActive(!!r.data.melo_monday_active)).catch(() => {});
  }, []);

  if (!active) return null;
  return (
    <div
      data-testid="melo-monday-banner"
      className="relative overflow-hidden border-b border-[#FF4500]/40 bg-[#FF4500] text-black"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-2 flex items-center justify-center gap-3 font-mono text-xs uppercase tracking-[0.25em]">
        <Flame className="h-4 w-4 shrink-0" />
        <span className="font-bold">Melo Mondays</span>
        <span className="hidden sm:inline opacity-85">— one free song hidden on every profile. Start digging!!</span>
        <span className="sm:hidden opacity-85">— free songs on every profile</span>
      </div>
    </div>
  );
}
